export class NoStorage {
    get(_key) {
        return null;
    }
    set(_key, _value, _ttl) {
        // Do nothing
    }
    delete(_key) {
        // Do nothing
    }
}
